
const shouldShowDealTimerProductUtil = (endTime, currentDate) => {
  if (!endTime || !currentDate) {
    return false
  }

  const difference = new Date(endTime) - new Date(currentDate)

  if (difference <= 0) {
    return false
  }

  return true
}

export default shouldShowDealTimerProductUtil
